export const environment = {
  production: false,
  API_BASE_URL: 'https://dev.cpo.cehive.in'
};
